import React from "react";
import BottomSheet from "./BottomSheet";
import css from "./partnersMobile.module.css";

const COPY = {
  approve: {
    title: (name) => `Approve ${name}`,
    body: "The partner is verified and gains access to the partner portal.",
    confirm: "Approve partner",
    className: "btnPrimary",
  },
  reject: {
    title: (name) => `Reject ${name}`,
    body: "You will be asked for a reason on the next screen.",
    confirm: "Reject application",
    className: "btnDanger",
  },
  // No Suspend entry: Suspend opens SuspendCpSummary directly, which is its
  // own confirmation step (as on desktop).
};

export default function ConfirmSheet({
  open,
  action,
  name,
  onConfirm,
  onCancel,
}) {
  const copy = COPY[action];
  if (!copy) return null;

  return (
    <BottomSheet
      open={open}
      title={copy.title(name)}
      onClose={onCancel}
      footer={
        <>
          <button
            type="button"
            className={`${css.btn} ${css.btnSecondary}`}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`${css.btn} ${css[copy.className]}`}
            onClick={onConfirm}
          >
            {copy.confirm}
          </button>
        </>
      }
    >
      <p style={{ margin: 0, fontSize: 14, lineHeight: "20px", color: "#667085" }}>
        {copy.body}
      </p>
    </BottomSheet>
  );
}
